import React, { useEffect, useLayoutEffect, useState } from 'react';
import './vote-game.css';
import {
    goBack,
    goToScreen,
    goToScreenAndReset,
    setHistoryScreenState,
} from '../../actions/router';
import { connect } from 'react-redux';
import {
    MAIN_GAME_SCREEN,
    QUICKPLAY_SCREEN,
    SETTINGS_SCREEN,
    VOTE_GAME_SCREEN,
} from '../../constants/routes';
import Copy from '../../copy/vote';
import classNames from 'classnames';
import { completeTutorial } from '../../actions/tutorials';
import {
    progressTime,
    removePhoneCall,
    updateOverallScores,
} from '../../actions/active-game';
import { Panel } from '../../components/panel';
import { IconButton } from '../../components/icon-button';
import { TutorialModalParent } from '../../components/modal-parents/tutorial-modal';
import { ProgressUpdateModalParent } from '../../components/modal-parents/progress-update-modal';
import { Heading } from '../../components/heading';
import { Vote } from './vote';
import { selectRandomArrayEntry } from '../../helpers/active-game';

const VoteGameScreen = props => {
    const {
        goBack,
        goToSettings,
        continueTo,
        continueRoute,
        historyScreenState,
        tutorialCompleted,
        completeVotesTutorial,
        previousScores,
        submitOverallScores,
        currentCall,
        difficulty,
        progressGame,
        removePhoneCallFromCalendar,
    } = props;

    const [activeVote, setActiveVote] = useState(null);

    const [currentGameScores, setCurrentGameScores] = useState({});
    const [progressUpdateVisible, setProgressUpdateVisible] = useState(false);
    const [responseFeedback, setResponseFeedback] = useState(null);

    const modalVisible = progressUpdateVisible || !tutorialCompleted;
    const votes = Copy.votes[difficulty];

    useEffect(() => {
        if (continueRoute === QUICKPLAY_SCREEN) {
            const randomTopic = selectRandomArrayEntry(Object.keys(votes));
            setActiveVote(randomTopic);
        } else {
            setActiveVote(currentCall.taskID);
        }
    }, [continueRoute, currentCall, votes]);

    useLayoutEffect(() => {
        if (historyScreenState.screen === VOTE_GAME_SCREEN) {
            setActiveVote(historyScreenState.state.activeVote);
        }
    }, [historyScreenState]);

    const submitResponse = decision => {
        const voteDecision = votes[activeVote][decision];
        const scores = {
            party: voteDecision.score_party,
            voters: voteDecision.score_local,
            media: voteDecision.score_media,
        };
        setCurrentGameScores(scores);
        setResponseFeedback(voteDecision.feedback);
        setProgressUpdateVisible(true);
    };

    const completeGame = () => {
        if (continueRoute === MAIN_GAME_SCREEN) {
            submitOverallScores(previousScores, currentGameScores);
            removePhoneCallFromCalendar(currentCall.phone_callID);
            progressGame();
        }
        continueTo(continueRoute);
    };

    const votePageClasses = classNames({
        'vote-game': true,
        'vote-game--hidden': modalVisible,
    });

    return (
        <>
            <div className={votePageClasses} aria-hidden={modalVisible}>
                <IconButton
                    iconName="back"
                    size="small"
                    type="essential"
                    withSpacing={true}
                    onClick={() => {
                        if (continueRoute === MAIN_GAME_SCREEN) {
                            removePhoneCallFromCalendar(
                                currentCall.phone_callID,
                            );
                        }
                        goBack();
                    }}
                    isDisabled={modalVisible}
                />
                <Panel
                    flexDirection="column"
                    withPadding={false}
                    color="purple"
                    currentPage="vote game game"
                >
                    <div className="vote-game__header">
                        <Heading colorScheme="dark">{Copy.heading}</Heading>
                    </div>
                    {activeVote && (
                        <Vote
                            topic={votes[activeVote]}
                            voteAye={() => submitResponse('vote_for')}
                            voteNo={() => submitResponse('vote_against')}
                            modalVisible={modalVisible}
                        />
                    )}
                </Panel>
                <IconButton
                    iconName="settings"
                    size="small"
                    type="essential"
                    withSpacing={true}
                    onClick={() => goToSettings(activeVote)}
                    isDisabled={modalVisible}
                />
            </div>
            {!tutorialCompleted && (
                <TutorialModalParent
                    screen="vote"
                    onClick={() => completeVotesTutorial()}
                />
            )}
            {progressUpdateVisible === true && (
                <ProgressUpdateModalParent
                    previousScores={previousScores}
                    gameScores={currentGameScores}
                    feedback={responseFeedback}
                    onClick={() => completeGame()}
                />
            )}
        </>
    );
};

const mapStateToProps = state => {
    return {
        history: state.router.history,
        continueRoute: state.router.history[state.router.history.length - 2],
        historyScreenState: state.router.historyScreenState,
        tutorialCompleted:
            state.activeGame.tutorialsCompleted[VOTE_GAME_SCREEN],
        previousScores: state.activeGame.overallScores,
        currentCall: state.activeGame.currentCall,
        difficulty: state.settings.gameSettings.difficulty,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        goBack: () => {
            dispatch(goBack());
        },
        goToSettings: activeVote => {
            dispatch(
                setHistoryScreenState(VOTE_GAME_SCREEN, {
                    activeVote,
                }),
            );
            dispatch(goToScreen(SETTINGS_SCREEN));
        },
        continueTo: route => {
            dispatch(goToScreenAndReset(route));
        },
        completeVotesTutorial: () => {
            dispatch(completeTutorial(VOTE_GAME_SCREEN));
        },
        submitOverallScores: (previousScores, gameScores) => {
            dispatch(updateOverallScores(previousScores, gameScores));
        },
        removePhoneCallFromCalendar: phoneCallId => {
            dispatch(removePhoneCall(phoneCallId));
        },
        progressGame: () => {
            dispatch(progressTime('vote'));
        },
    };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(VoteGameScreen);
export { connected as VoteGameScreen };
